import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "@redux/app-state";

export const selectExternalProviderInvoiceSubmission = createSelector(
  [(state: AppState) => state.externalProvider.invoiceSubmission],
  state => state,
);
